import React, { useState, useEffect } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { useDispatch, useSelector } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import SendReminderView from "../../../../Shared/Component/SendReminder/SendReminderView";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import ModalHeader from "../../../../Components/Header/ModalHeader";
import AshaIndividualView from "../AshaIndividualView/AshaIndividualView";
import AnmIndividualView from "../AnmIndividualView";
import "./AshaAnmModalView.scss";
import * as dashboardSelectors from "../../../../Store/Dashboard/DashboardSelectors";
import { useLanguage } from "../../../ChangeLanguage/LanguageProvider";
import { fetchTotalAshaAnmData } from "../../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionActions";
import {
  headerStyle,
  ashaDetailFilterTemplate,
  reminderBodyTemplate,
} from "../../../../Shared/Utils/tableColumns";
import { getTotalAshaAnmTableList, totalAshaAnmPaginationData } from "../../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionSelectors";
import { useTranslation } from "react-i18next";
const paginationConstants = {
  defaultRows: 10,
  rowsPerPageOptions: [10, 20, 50],
};
const AshaAnmModal = ({ mode, index, ashaCount,
  anmCount, afCount, activeAshaCount, activeAnmCount, activeAfCount }) => {
  const [isStatus, setIsStatus] = useState(false);
  const areaType = useSelector(dashboardSelectors.getGlobalAreaType);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const ashasData = useSelector(getTotalAshaAnmTableList);
  const paginationData = useSelector(totalAshaAnmPaginationData);
  const { selectedLanguageId } = useLanguage();
  const dispatch = useDispatch();
  const currentYr = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const access_level_id = sessionStorage.getItem("access_level_id");
  const lgbId = sessionStorage.getItem("lgbId");
  const roles = ["ASHA"];
  const roles1 = ["ANM"];
  const roles2 = ["AF"];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const [, setApiMode] = useState("");
  const [tabIndex, setTabIndex] = useState(index);
  const [filters] = useState(null);
  const [chosenMonth2] = useState(months[currentMonth]);
  const [chosenYr2] = useState(currentYr);
  const modeRole =
    mode === "asha"
      ? "ASHA"
      : mode === "anm"
      ? "ANM"
      : "AF";
  const [chosenRole, setChosenRole] = useState(modeRole);
  const [chosenRole1, setChosenRole1] = useState("ANM");
  const [chosenRole2, setChosenRole2] = useState("AF");
  const [selectedItems, setSelectedItems] = useState([]);
  const [isAshaViewVisible, setIsAshaViewVisible] = useState(false);
  const [chosenAshaId, setChosenAshaId] = useState("");
  const [chosenIndex, setChosenIndex] = useState(null);
  const [, setStatusActive] = useState("");
  const [AName, setAName] = useState("");
  const [activeAshaList, setActiveAshaList] = useState([]);
  const [inactiveAshaList, setInactiveAshaList] = useState([]);
  const [inactiveDays, setInactiveDays] = useState(0);
  const { t } = useTranslation("TopAsha");
  const isAshaName =
    mode === "asha"
      ? t("ASHAName")
      : mode === "anm"
        ? t("ANMName")
        : t("AFName");
  useEffect(() => {
  dispatch(
    fetchTotalAshaAnmData(
      areaType,
      mode,
      chosenMonth2,
      chosenYr2,
      selectedLanguageId,
      tabIndex,
      page,
      pageSize
    )
  );
}, [dispatch, areaType, mode, chosenMonth2, chosenYr2, selectedLanguageId, tabIndex, page, pageSize]);

  useEffect(() => {
    if (mode === "anm") {
      setApiMode("ANM");
    } else if (mode === "af") {
      setApiMode("AF");
    } else {
      setApiMode("ASHA");
    }
  }, [mode]);
  const handleRoleChange = (val) => {
    setChosenRole(val); // Update the state with the new role value
    dispatch(fetchTotalAshaAnmData(areaType, val, selectedLanguageId, mode,page,pageSize));
  };

  const handleRoleChange1 = (val) => {
    setChosenRole1(val);
    dispatch(fetchTotalAshaAnmData(areaType, val, selectedLanguageId,mode,page,pageSize));
  };

  const handleRoleChange2 = (val) => {
    setChosenRole2(val);
    dispatch(fetchTotalAshaAnmData(areaType, val, selectedLanguageId, mode,page,pageSize));
  };

  useEffect(() => {
    if (ashasData) {
      let activeList = [];
      let inactiveList = [];
      ashasData.forEach((item) => {
        handActive(!item.isActive);
        item.isActive ? activeList.push(item) : inactiveList.push(item);
      });
      setActiveAshaList(activeList);
      setInactiveAshaList(inactiveList);
    }
  }, [ashasData]);
  function handActive(status) {
    setStatusActive(status);
  }
  const handleTabChange = ({ index }) => {
    setTabIndex(index);
    const selectedRole = modeRole;
    setChosenRole(selectedRole);
    dispatch(
      fetchTotalAshaAnmData(
        areaType,
        selectedRole,
        chosenMonth2,
        chosenYr2,
        selectedLanguageId,
        index,
        page,pageSize
      )
    );
  };

  const handleCellClick = (
    index,
    ashaId,
    isActive,
    ashaName,
    inactiveSince
  ) => {
    setChosenAshaId(ashaId);
    setIsAshaViewVisible(true);
    setChosenIndex(index);
    setIsStatus(isActive);
    setAName(ashaName);
    setInactiveDays(inactiveSince);
  };

  const ashaDetailBodyTemplate = ({
    ashaId,
    ashaName,
    isActive,
    inactiveSince,
  }) => {
    return (
      <div
        className="text-blue-600 font-normal cursor-pointer"
        onClick={() =>
          handleCellClick(0, ashaId, isActive, ashaName, inactiveSince)
        }
        onKeyDown={() =>
          handleCellClick(0, ashaId, isActive, ashaName, inactiveSince)
        }
      >
        {ashaName}
      </div>
    );
  };

  const filteredData = activeAshaList.filter(
    (asha) => asha.role === chosenRole && asha.isActive
  );
  const filteredData1 = inactiveAshaList.filter(
    (asha) => asha.role === chosenRole && !asha.isActive
  );
  const filteredDataANM = activeAshaList.filter(
    (anm) => anm.role === chosenRole1 && anm.isActive
  );
  const filteredDataAF = activeAshaList.filter(
    (af) => af.role === chosenRole2 && af.isActive
  );
  const filteredInactiveANM = inactiveAshaList.filter(
    (anm) => anm.role === chosenRole1 && !anm.isActive
  );
  const filteredInactiveAF = inactiveAshaList.filter(
    (af) => af.role === chosenRole2 && !af.isActive
  );
  const ashaTotal = () => {
    return filteredData.length + filteredData1.length;
  };
  const anmTotal = () => {
    return filteredDataANM.length + filteredInactiveANM.length;
  };
  console.log("anmTotal",anmTotal,ashaTotal);
  const isTotalAshaAnm =
    mode === "asha"
      ? ashaCount
      : mode === "anm"
        ? anmCount
        : afCount;
  const isFilteredDa1Fun = () => {
    if (mode === "asha") {
      return filteredData;
    } else if (mode === "af"){
      return filteredDataAF;
    } else {
      return filteredDataANM;
    }
  };
  const isFilteredDa2Fun = () => {
    if (mode === "asha") {
      return filteredData1;
    } else if (mode === "af") {
      return filteredInactiveAF;
    } else {
      return filteredInactiveANM;
    }
  };

  const isFilteredDa1 = isFilteredDa1Fun();
  const isFilteredDa2 = isFilteredDa2Fun();
  const isFilteredFun = () => {
    if (tabIndex === 0) {
      return isFilteredDa1;
    } else {
      return isFilteredDa2;
    }
  };
  const isFiltered = isFilteredFun();
  const generateColumn = (field, header, t) => {
    return (
      <Column
        field={field}
        header={t(header)}
        filter
        showFilterMenu={false}
        filterElement={(options) => ashaDetailFilterTemplate(options, t)}
      />
    );
  };
  const handleTablePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
  };
  const handlePageChange = (e) => {
    handleTablePageChange(e.page + 1, e.rows);
  };
  const renderDataTable = (data) => {
    return (
      <>
        <DataTable
          lazy
          resizableColumns
          selectionMode={"checkbox"}
          value={ashasData}
          dataKey="ashaId"
          size="small"
          filters={filters}
          emptyMessage="No data found."
          filterDisplay="row"
          selection={selectedItems}
          onSelectionChange={(e) => {
            setSelectedItems(e.value);
          }}
          scrollable
          scrollHeight="510px"
          className="AshaModaltableClass"
          paginator
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          rows={pageSize}
          first={(page - 1) * pageSize}
          totalRecords={paginationData?.totalCount}
          paginatorLeft={<div style={{ textAlign: "left", width: "100%" }} />}
          paginatorRight={null}
          onPage={handlePageChange}
          rowsPerPageOptions={paginationConstants.rowsPerPageOptions}
        >
          <Column
            frozen={true}
            selectionMode="multiple"
            header={t("Select All")}
            alignFrozen="left"
          ></Column>

          <Column
            field="ashaName"
            header={isAshaName}
            filter
            frozen={true}
            showFilterMenu={false}
            filterElement={(options) => ashaDetailFilterTemplate(options, t)}
            body={ashaDetailBodyTemplate}
            alignFrozen="left"
          />
          <Column
            field="ashaId"
            header={
              mode === "asha"
                ? t("ASHAId")
                : mode === "anm"
                  ? t("ANMId")
                  :t("AFId")
            }
            filter
            frozen={true}
            showFilterMenu={false}
            filterElement={(options) => ashaDetailFilterTemplate(options, t)}
            alignFrozen="left"
          />
          {generateColumn("contactNo", "ContactNo", t)}

          <Column
            frozen={true}
            headerStyle={headerStyle}
            bodyStyle={headerStyle}
            alignFrozen="left"
          />
          {generateColumn("stateName", "State", t)}
          {generateColumn("districtName", "District", t)}
          {(Number(access_level_id) === 5 && Number(lgbId) ===  5) ? (
            <></>
          ): (generateColumn("talukaName", "Taluka", t))}
          {generateColumn("phcName", "PHC", t)}
          {((Number(access_level_id) === 5 && Number(lgbId) ===  5) || (Number(access_level_id) === 1 && areaType ===  "Urban")) ? (
            <></>
          ):( generateColumn("subcenterName", "Subcenter", t))}

          <Column
            field="joiningDate"
            header={t("JoiningDate")}
            filter
            showFilterMenu={false}
            filterElement={(options) => ashaDetailFilterTemplate(options, t)}
          />
          <Column
            frozen={true}
            headerStyle={headerStyle}
            bodyStyle={headerStyle}
            alignFrozen="right"
          />

          <Column
            field="reminderCount"
            header={t("ReminderStatus")}
            filter
            showFilterMenu={false}
            frozen={true}
            filterElement={(options) => ashaDetailFilterTemplate(options, t)}
            body={reminderBodyTemplate}
            alignFrozen="right"
          />
          {!isFiltered.isActive && tabIndex === 1 && (
            <Column
              field="inactiveSince"
              header={t("lastActive")}
              alignFrozen="right"
              frozen={true}
              filter
              showFilterMenu={false}
              filterElement={(options) => ashaDetailFilterTemplate(options, t)}
            />
          )}
        </DataTable>
      </>
    );
  };

  return (
    <div className="asha-card">
      <div className="grid align-items-center justify-content-between">
        <div className="sm:col-12 md:col-10 lg:col-10 flex flex-wrap align-items-center">
          <p className="text-xl font-light ml-2">
            {t("total")}{" "}
            {mode === "asha"
              ? t("ASHA :")
              : mode === "anm"
                ? t("ANM :")
                : t("AF :")}
            {isTotalAshaAnm}
          </p>
          <div className="ml-2 mr-2">
            <Dropdown
              data-testid="role-test"
              value={mode === "asha" ? chosenRole : mode === "anm" ? chosenRole1 : chosenRole2}
              onChange={(e) =>
                mode === "asha"
                  ? handleRoleChange(e.target.value)
                : mode === "anm"
                  ? handleRoleChange1(e.target.value)
                : handleRoleChange2(e.target.value)
              }
              options={
                mode === "asha"
                  ? roles
                  : mode === "af"
                    ? roles2
                    : roles1
              }
              className="cockpit-dropdown"
              disabled
            />
          </div>
        </div>
        <div className="sm:col-12 md:col-2 lg:col-2">
          <SendReminderView
            ashaIds={selectedItems.map((item) => item.ashaId)}
            isDisabled={selectedItems.length === 0}
          />
        </div>
      </div>
      <TabView activeIndex={tabIndex} onTabChange={handleTabChange}>
        <TabPanel
          header={`${t("active")} ${mode === "asha"
            ? activeAshaCount
            : mode === "anm"
              ? activeAnmCount
              : activeAfCount
            }`}
        >
          {renderDataTable(
            mode === "asha"
              ? filteredData
              : mode === "anm"
                ? filteredDataANM
                : filteredDataAF
          )}
        </TabPanel>
        <TabPanel
          header={`${t("inactive")} ${mode === "asha"
            ? ashaCount - activeAshaCount
            : mode === "anm"
              ? anmCount - activeAnmCount
              : afCount - activeAfCount
            }`}
        >
          {renderDataTable(
            mode === "asha"
              ? filteredData1
              : mode === "anm"
                ? filteredInactiveANM
                : filteredInactiveAF
          )}
          <p>
            {mode === "asha"
              ? filteredData1.length
              : mode === "anm"
                ? filteredInactiveANM.length
                : filteredInactiveAF.length}{" "}
            {t("TotalRecords")}
          </p>
        </TabPanel>
      </TabView>
      <Dialog
        className="cockpit-dialog"
        visible={isAshaViewVisible}
        modal={true}
        position={"center"}
        draggable={false}
        resizable={false}
        onHide={() => setIsAshaViewVisible(false)}
        closeOnEscape={false}
        header={
          <ModalHeader
            onClose={() => setIsAshaViewVisible(false)}
            backText={"Back To Table"}
          />
        }
      >
        {mode === "anm" ? (
          <AnmIndividualView
            anmId={chosenAshaId}
            chosenActiveIndex={chosenIndex}
            isStatus={isStatus}
            name={AName}
          />
        ) : (
          <AshaIndividualView
            ashaId={chosenAshaId}
            chosenActiveIndex={chosenIndex}
            isStatus={isStatus}
            name={AName}
            inactiveSince={inactiveDays || []}
          />
        )}
      </Dialog>
    </div>
  );
};

export default AshaAnmModal;
